
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions",
      function () {
        return require("private-next-pages/questions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions"])
      });
    }
  